module.exports = __webpack_public_path__ + "assets/img/travel2.6881dde1.png";